var testimonialCarousal = (function () {

    function init() {
        var carousel = document.querySelector("[data-target='testimonial-carousel']"),
            allCards = document.querySelectorAll("[data-target='testimonial-card']"),
            card = document.querySelector("[data-target='testimonial-card']"),
            firstCard = allCards.length ? allCards[0] : null,
            lastCard = allCards.length ? allCards[allCards.length - 1] : null,
            leftButton = document.querySelector("[data-action='swipeLeft']"),
            rightButton = document.querySelector("[data-action='swipeRight']"),
            cardWidth = card ? card.offsetWidth : 0,
            cardStyle = card.currentStyle || window.getComputedStyle(card),
            cardMarginRight = Number(cardStyle.marginRight.match(/\d+/g)[0]),
            cardCount = allCards.length ? allCards.length : 0,
            offset = (window.innerWidth - cardWidth - cardMarginRight * 2) / 2,
            maxCardHeight = [],
            cardDesc = document.querySelectorAll('.carousel-testimonial-wrapper__card'),
            slideInterval;

        // set carousal code only when slides is greater 3 slides
        if (cardCount > 3 && carousel) {
            // set max height for desc text in slider
            for (var i = 0; i < cardDesc.length; i++) {
                maxCardHeight.push(cardDesc[i].offsetHeight);
            }

            for (var i = 0; i < allCards.length; i++) {
                allCards[i].style.transform = 'scaleY(0.9) translateX(-' + (cardWidth - offset) + 'px)';
                allCards[i].style.minHeight = Math.max.apply(Math, maxCardHeight) + 'px';
                allCards[i].setAttribute('aria-hidden', true);
                allCards[i].querySelector('a') ? allCards[i].querySelector('a').setAttribute('tabindex', '-1') : '';
                //mouse over events
                allCards[i].addEventListener("mouseover", function (event) {
                    clearInterval(slideInterval);
                }, false);

                //mouse out events
                allCards[i].addEventListener("mouseout", function (event) {
                    initiateSlideInterval();
                }, false);
            }

            // set first card as active
            if (firstCard) {
                firstCard.classList.add('is-active');
                firstCard.removeAttribute('aria-hidden');
                firstCard.querySelector('a') ? firstCard.querySelector('a').removeAttribute('tabindex') : '';
                firstCard.style.transform = 'scaleY(1) translateX(-' + (cardWidth - offset) + 'px)';
                firstCard.nextElementSibling.classList.add('is-next');
            }

            // Add the click events && set position for left and right button
            if (leftButton) {
                leftButton.addEventListener('click', function () {
                    clearInterval(slideInterval);
                    fnSlideToLeft();
                });
            }
            if (rightButton) {
                rightButton.addEventListener('click', function () {
                    clearInterval(slideInterval);
                    fnSlideToRight();
                });
            }

            // clone last card and make it as prev
            if (lastCard) {
                var clone = lastCard.cloneNode(true);
                clone.classList.add('is-prev');
                lastCard.remove();
                carousel.prepend(clone);
            }

            var offsetMain = 0, touchstartX = 0, touchendX = 0, slide = 1, gap = 20;

            function fnSlideToLeft() {
                cardWidth = carousel.querySelector("[data-target='testimonial-card']").offsetWidth;
                var getActiveSlide = document.querySelector(".is-active[data-target='testimonial-card']"),
                    getPrevSlide = document.querySelector(".is-prev[data-target='testimonial-card']"),
                    getNextSlide = document.querySelector(".is-next[data-target='testimonial-card']"),
                    getCardElem = document.querySelectorAll("[data-target='testimonial-card']"),
                    lastCardElem = getCardElem[getCardElem.length - 1];

                offsetMain += (cardWidth * slide) + (gap * slide);

                for (var i = 0; i < getCardElem.length; i++) {
                    getCardElem[i].style.transform = 'scaleY(0.9) translateX(' + ((-offsetMain) - (cardWidth - offset)) + 'px)';
                    getCardElem[i].setAttribute('aria-hidden', true);
                    getCardElem[i].querySelector('a') ? getCardElem[i].querySelector('a').setAttribute('tabindex', '-1') : '';
                }

                getActiveSlide.classList.remove('is-active');
                getPrevSlide.classList.remove('is-prev');
                getNextSlide.classList.remove('is-next');

                getPrevSlide.classList.add('is-active');
                getPrevSlide.removeAttribute('aria-hidden');
                getPrevSlide.querySelector('a') ? getPrevSlide.querySelector('a').removeAttribute('tabindex') : '';
                getPrevSlide.style.transform = 'scaleY(1) translateX(' + ((-offsetMain) - (cardWidth - offset)) + 'px)';
                getActiveSlide.classList.add('is-next');

                var clone = lastCardElem.cloneNode(true);
                clone.classList.add('is-prev');
                lastCardElem.remove();
                carousel.prepend(clone);

                clone.addEventListener("mouseover", function (event) {
                    clearInterval(slideInterval);
                }, false);

                clone.addEventListener("mouseout", function (event) {
                    initiateSlideInterval();
                }, false);

                carousel.style.transform = 'translateX(' + offsetMain + 'px)';

                //show images from lazy load
                lazyLoading.show();
            }

            function fnSlideToRight() {
                cardWidth = carousel.querySelector("[data-target='testimonial-card']").offsetWidth;
                var getActiveSlide = document.querySelector(".is-active[data-target='testimonial-card']"),
                    getPrevSlide = document.querySelector(".is-prev[data-target='testimonial-card']"),
                    getNextSlide = document.querySelector(".is-next[data-target='testimonial-card']"),
                    getCardElem = document.querySelectorAll("[data-target='testimonial-card']"),
                    firstCardElem = getCardElem[0];

                offsetMain -= (cardWidth * slide) + (gap * slide);

                carousel.style.transform = 'translateX(' + offsetMain + 'px)';

                for (var i = 0; i < getCardElem.length; i++) {
                    getCardElem[i].style.transform = 'scaleY(0.9) translateX(' + ((-offsetMain) - (cardWidth - offset)) + 'px)';
                    getCardElem[i].setAttribute('aria-hidden', true);
                    getCardElem[i].querySelector('a') ? getCardElem[i].querySelector('a').setAttribute('tabindex', '-1') : '';
                }

                getActiveSlide.classList.remove('is-active');
                getPrevSlide.classList.remove('is-prev');
                getNextSlide.classList.remove('is-next');

                getNextSlide.classList.add('is-active');
                getNextSlide.removeAttribute('aria-hidden');
                getNextSlide.querySelector('a') ? getNextSlide.querySelector('a').removeAttribute('tabindex') : '';
                getNextSlide.style.transform = 'scaleY(1) translateX(' + ((-offsetMain) - (cardWidth - offset)) + 'px)';
                getActiveSlide.classList.add('is-prev');
                getNextSlide.nextElementSibling.classList.add('is-next');

                var clone = firstCardElem.cloneNode(true);
                firstCardElem.remove();
                carousel.append(clone);

                clone.addEventListener("mouseover", function (event) {
                    clearInterval(slideInterval);
                }, false);

                clone.addEventListener("mouseout", function (event) {
                    initiateSlideInterval();
                }, false);

                //show images from lazy load
                lazyLoading.show();
            }

            // Auto Slide Fuctionality
            function initiateSlideInterval() {
                slideInterval = setInterval(function () {
                    fnSlideToRight();
                }, 5000);
            }

            initiateSlideInterval();

            //touch swipe
            carousel.addEventListener('touchstart', function (e) {
                touchstartX = e.changedTouches[0].screenX;
            }, { passive: true });

            carousel.addEventListener('touchend', function (e) {
                touchendX = e.changedTouches[0].screenX;
                clearInterval(slideInterval);

                //swipe left
                if (touchendX > touchstartX) {
                    fnSlideToLeft();
                }

                //swipe right
                if (touchendX < touchstartX) {
                    fnSlideToRight();
                }
            }, { passive: true });
        }
    }

    return {
        init: init
    };

})();

window.addEventListener("load", function () {
    testimonialCarousal.init();
});